export class MultiDispatchError extends Error {
  constructor(message) {
    super(message);
    this.name = 'MultiDispatchError';
  }
}
